import { openBlock as t, createElementBlock as o, renderSlot as n } from "vue";
/* empty css                  */
import r from "../../_virtual/_plugin-vue_export-helper.js";
const s = {
  name: "DsPageContent"
}, c = { class: "ds-page-content" };
function a(e, p, d, _, f, i) {
  return t(), o("div", c, [
    n(e.$slots, "default")
  ]);
}
const $ = /* @__PURE__ */ r(s, [["render", a]]);
export {
  $ as default
};
